import { isContactPersonMainFieldsFilled } from '../elements/CustomerModal/utils/contactPersons/contactPersonValidation'
import { CustomerType } from '../enums/customerType'
import { ContactPerson } from '../types/contactPerson'
import { CustomerForm } from '../types/customerForm'
import { getContactPersonsWithoutPrimaryContact } from './getContactPersonsWithoutPrimaryContact'

export const createContactPersonsFromFormData = (formData: CustomerForm): ContactPerson[] => {
  const { contactPersons = [], customerType, email, firstName, lastName } = formData
  const isIndividual = customerType === CustomerType.Individual

  if (!isIndividual) {
    return contactPersons
  }

  const hasPrimaryContact = isContactPersonMainFieldsFilled(email, firstName, lastName)
  const contactPersonsWithoutPrimaryContact = getContactPersonsWithoutPrimaryContact(contactPersons)

  if (!hasPrimaryContact) {
    return contactPersonsWithoutPrimaryContact
  }

  return [
    {
      email,
      firstName,
      lastName,
      isPrimary: true,
    },
    ...contactPersonsWithoutPrimaryContact,
  ]
}
